module.exports = __webpack_public_path__ + "img/app6.302da684.png";